/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ApiErrorResponse,
  IUpdateExceptionList,
} from "@/@types/exception-list";
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { toast } from "@/components/ui/use-toast";
import {
  useGetExceptionListByIdQuery,
  useUpdateExceptionListMutation,
} from "@/services/exception-list";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { SelectDate } from "./components/select-date";
import { FormSchema } from "./validation.form";

interface ModalEditExceptionProps {
  requestData: { id: number };
  onCloseModal?: () => void;
}

export function ExceptionListEditModal({
  requestData,
  onCloseModal,
}: ModalEditExceptionProps) {
  const { data: exceptionResponse } = useGetExceptionListByIdQuery(
    requestData.id
  );
  const [updateException, { isLoading }] = useUpdateExceptionListMutation();

  const form = useForm<IUpdateExceptionList>({
    resolver: zodResolver(FormSchema),
    values: exceptionResponse as IUpdateExceptionList | undefined,
  });

  const onSubmit = async (data: IUpdateExceptionList) => {
    try {
      await updateException({
        id: requestData.id,
        body: { final_term: data.final_term },
      }).unwrap();

      toast({
        variant: "success",
        description: "Fim da Vigência atualizado com sucesso!",
      });
      onCloseModal?.();
    } catch (e: any) {
      const err = e as { data: ApiErrorResponse };
      toast({
        variant: "destructive",
        description:
          err.data?.messages?.[0] || "Erro inesperado ao atualizar exceção.",
        duration: 5000,
      });
    }
  };

  return (
    <div className="relative z-[9999] p-10 space-y-6 w-[520px] rounded-lg shadow-lg bg-white overflow-visible">
      <h2 className="text-xl font-semibold text-gray-800 border-b pb-2">
        Atualizar Fim da Vigência
      </h2>

      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="flex flex-col space-y-8 w-full"
        >
          <FormField
            control={form.control}
            name="final_term"
            render={({ field }) => (
              <FormItem className="w-full">
                <Label className="text-gray-700 font-medium">
                  Data Final da Vigência
                </Label>
                <SelectDate
                  value={field.value}
                  onChange={field.onChange}
                  id="final_term"
                  label=""
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="flex justify-end gap-4 items-center">
            <Button
              type="button"
              variant="outline"
              onClick={() => onCloseModal?.()}
              className="w-32"
            >
              Cancelar
            </Button>
            <Button type="submit" className="w-32" disabled={isLoading}>
              {isLoading ? "Salvando..." : "Salvar"}
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}
